import { render, staticRenderFns } from "./social-share-cmp.vue?vue&type=template&id=867d44bc&scoped=true&functional=true"
import script from "./social-share-cmp.vue?vue&type=script&lang=js"
export * from "./social-share-cmp.vue?vue&type=script&lang=js"
import style0 from "./social-share-cmp.vue?vue&type=style&index=0&id=867d44bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "867d44bc",
  null
  
)

export default component.exports